import { render, staticRenderFns } from "./warehouse-modal.vue?vue&type=template&id=3836f9f4&"
import script from "./warehouse-modal.vue?vue&type=script&lang=js&"
export * from "./warehouse-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports